import type { AlertasData } from "../types";
import { IconAlert } from "../icons";

interface Props {
  data: AlertasData | null;
  onVer: () => void; // abre a aba "Alertas de Estoque"
}

/** Faixa de aviso (chama a atenção) quando há itens abaixo do mínimo/zerados. */
export default function AlertasBanner({ data, onVer }: Props) {
  if (!data || data.total === 0) return null;
  const partes: string[] = [];
  if (data.zerados > 0) partes.push(`${data.zerados} zerado(s)`);
  if (data.abaixo > 0) partes.push(`${data.abaixo} abaixo do mínimo`);

  return (
    <div className="alert-banner" role="alert">
      <span className="alert-banner-ic">
        <IconAlert size={22} />
      </span>
      <div className="alert-banner-txt">
        <strong>
          {data.total} {data.total === 1 ? "item precisa" : "itens precisam"} de atenção no estoque
        </strong>
        <span>{partes.join(" · ")} — providenciar reposição/compra</span>
      </div>
      <button className="btn-light" onClick={onVer}>
        Ver alertas
      </button>
    </div>
  );
}
